import React, { useMemo, useState } from "react";
import { PublicCatalogue } from "../../pages";
import { FashCreativesController } from "../../controllers";
import { fashCreativeStore } from "../../stores";

const PublicCatalogueContainer = () => {
  const modalConstant = {
    close: "CLOSE",
    addCatalogue: "ADD",
    singleCatalogue: "SINGLE",
    editCatalogue: "EDIT",
  };

  const [openCatalogue, setOpenCatalogue] = useState(modalConstant.close);

  const openCatalogueHandler = (nav, catalogue) => {
    setOpenCatalogue(nav);
    if (catalogue) {
      fashCreativeStore.setSingleCatalogue(catalogue);
    }
  };

  const closeModal = () => {
    fashCreativeStore.setCollections([]);
    setOpenCatalogue(modalConstant.close);
  };

  const [limit, setLimit] = useState(50);
  const [filterQuery, setFilterQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");

  const catalogueTableQuery = useMemo(() => {
    return `offset=${currentPage + 1}&limit=${limit}`;
  }, [currentPage, limit]);

  const onLimitChange = (limit) => {
    setLimit(limit);
    setCurrentPage(0);
  };

  const { isLoading, data, isFetching } =
    FashCreativesController.useGetAddedCatalogues(
      catalogueTableQuery,
      filterQuery,
      searchQuery
    );

  return (
    <PublicCatalogue
      modalConstant={modalConstant}
      openCatalogue={openCatalogue}
      closeModal={closeModal}
      isLoading={isLoading}
      catalogueData={data}
      isFetching={isFetching}
      limit={limit}
      onLimitChange={onLimitChange}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      setSearchQuery={setSearchQuery}
      setFilterQuery={setFilterQuery}
      openCatalogueHandler={openCatalogueHandler}
    />
  );
};

export default PublicCatalogueContainer;
